import React from 'react';
import { Row, Col } from 'react-bootstrap'; // Removed Container, Card
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Header from '../../../components/common/Header';
import CourseForm from './CourseForm';

const CreateCourse = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/admin/courses');
  };

  const handleCancel = () => {
    navigate('/admin/courses');
  };

  return (
    <div>
      <Header />
      <div className="container-fluid p-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <div className="d-flex align-items-center">
              <button 
                className="btn btn-outline-secondary me-3"
                onClick={() => navigate('/admin/courses')}
              >
                <FaArrowLeft className="me-2" /> Back
              </button>
              <h2>Create New Course</h2>
            </div>
            <p className="text-muted">Fill in the details below to create a new course</p>
          </Col>
        </Row>

        <CourseForm 
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default CreateCourse;